import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { Team } from 'dashboard/models/team';
import { setTeam, setTeamUserIds } from 'dashboard/redux/actions/team';
import { DashboardThunkAction } from 'dashboard/redux/types';
import { ApiEndpoint } from 'lib/interfaces/api';

export const loadTeam =
  (id: string): DashboardThunkAction<Promise<void>> =>
  async (dispatch) => {
    const { data: team } = await SessionClientDashboard.getResource<Team>(ApiEndpoint.Team, id);
    dispatch(setTeam(team));
  };

export const loadTeamUserIds =
  (id: string): DashboardThunkAction<Promise<void>> =>
  async (dispatch) => {
    const response = await SessionClientDashboard.get<{ meta: { 'team-user-ids': string[] } }>(
      ApiEndpoint.Team,
      id,
      'load-team-user-ids',
    );
    dispatch(setTeamUserIds(response.meta['team-user-ids']));
  };
